import { combineReducers } from '@reduxjs/toolkit';
import { receivedPaymentsReducer } from './recievedPayments';

const paymentsReducer = combineReducers({
  recievedPayments: receivedPaymentsReducer,
});

export default paymentsReducer;
